import React, { useEffect, useState } from 'react';
import { SideMenuItems } from 'modules/shared/components/Navigation/SideMenuItems';
import { IconButton } from '@springcare/sh-component-library';
import { Box, useMediaQuery } from '@chakra-ui/react';
import { CloseIcon, HamburgerIcon } from '@chakra-ui/icons';
import { desktopMediaQueryWidth, sideNavWidth } from './constants/styles';

export const MobileSideMenu = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const bodyElement = document.querySelector('body');

    if (bodyElement) {
      bodyElement.style.overflow = open ? 'hidden' : 'unset';
    }
  }, [open]);

  const [isDesktop] = useMediaQuery(desktopMediaQueryWidth);

  return (
    <>
      <IconButton
        size="sm"
        variant="no-emphasis"
        icon={HamburgerIcon}
        aria-label="open menu"
        position="absolute"
        onClick={() => setOpen(true)}
      />
      <Box
        as="nav"
        aria-hidden={!open}
        display={isDesktop ? 'none' : 'block'}
        width={sideNavWidth}
        position="absolute"
        zIndex={3}
        height="100vh"
        borderRight={`2px solid #eff1f1`}
        left={open ? 0 : -sideNavWidth}
        transition={'all 0.3s ease-in-out'}
        overflowX={'scroll'}
        data-testid="mobile-side-menu"
        backgroundColor="white"
      >
        <IconButton
          variant="low-emphasis"
          size="xs"
          icon={CloseIcon}
          aria-label={'close'}
          onClick={() => setOpen(false)}
        />
        <SideMenuItems menuOpen={true} />
      </Box>
    </>
  );
};
